import { styled } from '@mui/material';

const PREFIX = 'RolloverStatus';

export const classes = {
  container: `${PREFIX}-container`,
};

export const Root = styled('div')(() => ({
  [`&.${classes.container}`]: {
    overflow: 'auto',
    maxHeight: '60vh',
  },
}));